import { Modal } from 'antd';
import { ThemeProvider } from 'antd-style';
import { FiX } from 'react-icons/fi';
import { useSelector } from 'react-redux';
import { Button } from '../ui/Button';
import { AppTooltip } from '../ui/AppTooltip';

export const DirectoryFormModal = ({ open, onClose, onSubmit, title, description, icon: Icon, submitLabel, submitVariant = 'primary', cancelLabel, closeLabel, submitting, children, width = 760 }) => {
  const isDarkMode = useSelector((state) => state.darkMode.isDarkMode);
  return (
    <ThemeProvider appearance={isDarkMode ? 'dark' : 'light'}>
      <Modal open={open} onCancel={onClose} closable={false} footer={null} centered width={width} className='directory-form-modal' style={{ '--directory-modal-width': `${width}px` }} destroyOnClose>
        <section className='directory-form-shell'>
          <header className='flex items-start gap-3 border-b border-[var(--border-subtle)] px-5 py-4 pr-16 sm:px-6'>
            <span className='flex h-11 w-11 shrink-0 items-center justify-center rounded-[var(--radius-md)] bg-[var(--brand-soft)] text-[var(--brand)]'>
              <Icon className='h-5 w-5' aria-hidden='true' />
            </span>
            <div className='min-w-0'>
              <h2 className='text-xl font-bold text-[var(--text-primary)] sm:text-2xl'>{title}</h2>
              <p className='mt-1 text-sm text-[var(--text-secondary)]'>{description}</p>
            </div>
            <AppTooltip label={closeLabel}><button type='button' onClick={onClose} disabled={submitting} className='absolute right-5 top-5 flex h-9 w-9 items-center justify-center rounded-[var(--radius-md)] text-[var(--text-secondary)] hover:bg-[var(--surface-panel-muted)]' aria-label={closeLabel}>
              <FiX className='h-5 w-5' />
            </button></AppTooltip>
          </header>
          <form onSubmit={onSubmit} className='directory-form-body'>
            <div className='directory-form-fields'>{children}</div>
            <footer className='flex flex-col-reverse gap-3 border-t border-[var(--border-subtle)] pt-4 sm:flex-row sm:justify-end'>
              <Button type='button' variant='secondary' onClick={onClose} disabled={submitting}>{cancelLabel}</Button>
              <Button type='submit' variant={submitVariant} loading={submitting}>{submitLabel}</Button>
            </footer>
          </form>
        </section>
      </Modal>
    </ThemeProvider>
  );
};
